export default "__VITE_ASSET__BiIzqeIp__"